import { Meta, Title } from '@angular/platform-browser';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { services } from '../../services';
import { TranslationService } from '../../../../../../shared/services/translations.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'cs2-premier',
  templateUrl: './cs2-premier.component.html'
})
export class Cs2PremierComponent {
  service = 'divisions';
  availableServices = services['cs2'].filter(service => service.service !== this.service);

  serviceParams = {
    game: 'cs2',
    service: 'divisions',
    type: 'solo',
    title: {
      en: 'Premier Boosting',
    },
    queue: 'premier',
    subtitle: {
      en: "Get your Desired Counter Strike 2 Premier CS Rating in Solo or Duo Boosting",
      fr: "Obtenez votre rang souhaitée sur Counter Strike 2 Premier en Solo ou Duo Boosting",
      de: "Erhalte dein gewünschtes Counter Strike 2 Premier CS Rating im Solo oder Duo Boosting",
      pt: "Obtém o teu Premier CS Rating desejado para Counter Strike 2 em Solo ou Duo Boosting",
      es: "Obtén tu puntuación deseada en Counter Strike 2 Premier CS en Solo o Duo Boosting",
    },
    start: 5,
    desired: 10
  }

  serviceFaqs = {
    en: [
      {
        question: "What Exactly Is A Premier CS Rating Boost Service?",
        answer: "A Premier Boosting service is the best way to guarantee that top-tier boosters will obtain your desired CS Rating."
      },
      {
        question: "What If I Demote Before The Service Is Complete?",
        answer: "Our services are 100% guaranteed. If any issues arise, we will quickly fix them and ensure you reach your target CS Rating."
      },
      {
        question: "Can I Play Together With The Booster?",
        answer: "Certainly! You can accomplish that by clicking the \"DUO\" red button found in the order additions menu."
      },
      {
        question: "Can I Pick My Booster Schedule?",
        answer: "Yes, you can. When you place an order you can add your schedule as a note to your booster, or you can discuss any details with your booster, including setting up a schedule., on the order chat."
      },
      {
        question: "Can I Play While The Order Is Active?",
        answer: "Yes, you can, unless you want to play Premier. In case of any other mode just pause or schedule it with your booster and have fun!"
      },
      {
        question: "Can I Request The Same Booster For A Future Purchase?",
        answer: "Yes! Click the heart icon inside the order dashboard to favorite a booster, then easily reassign them to your future orders."
      }
    ],
    fr: [
      {
        question: "Qu\'est-ce qu\'un service de Boost de rang CS?",
        answer: "Un service Boosting Premier est le meilleur moyen de garantir que les meilleurs boosters obtiendront le rang CS désiré."
      },
      {
        question: "Que se passe-t-il si je rétrograde avant la fin du service?",
        answer: "Nos services sont garantis à 100%. Si un problème survient, nous le réglerons rapidement et nous nous assurerons que vous atteignez votre notation CS ciblée."
      },
      {
        question: "Puis-je jouer avec le booster?",
        answer: "Certainement ! Vous pouvez le faire en cliquant sur le bouton rouge \"DUO\" qui se trouve dans le menu des ajouts à la commande."
      },
      {
        question: "Puis-je choisir le planning de mon booster?",
        answer: "Oui, vous le pouvez. Lorsque vous passez une commande, vous pouvez ajouter votre planning sous forme de note à votre booster, ou vous pouvez discuter de tous les détails avec votre booster, y compris la mise en place d\'un planning, sur le chat de la commande."
      },
      {
        question: "Puis-je jouer pendant que la commande est active?",
        answer: "Oui, sauf si vous souhaitez jouer Premier. Dans le cas d\'un autre mode, mettez simplement en pause ou planifiez avec votre booster et faites-vous plaisir!"
      },
      {
        question: "Puis-je demander le même booster pour un prochain achat?",
        answer: "Absolument. Il vous suffit d\'évaluer positivement votre booster et notre système vous donnera la possibilité de le solliciter automatiquement pour de futurs services."
      }
    ],
    de: [
      {
        question: "Was genau ist ein Premier CS Rating Boost Service?",
        answer: "Ein Premier Boosting-Service ist der beste Weg, um sicherzustellen, dass erstklassige Booster dein gewünschtes CS-Rating erreichen."
      },
      {
        question: "Was ist, wenn ich vor Abschluss des Services degradiere?",
        answer: "Unser Service ist zu 100% garantiert. Sollte es einmal zu Problemen kommen, werden wir diese schnellstmöglich beheben und dafür sorgen, dass du dein angestrebtes CS Rating erreichst."
      },
      {
        question: "Kann ich mit dem Booster zusammen spielen?",
        answer: "Aber sicher! Das kannst du erreichen, indem du auf die rote Schaltfläche \"DUO\" im Bestellungszusatzmenü klickst."
      },
      {
        question: "Kann ich meinen Booster-Zeitplan selbst bestimmen?",
        answer: "Ja, das kannst du. Wenn du bestellst, kannst du deinen Stundenplan als Notiz an deinen Booster anhängen oder alle Details mit deinem Booster im Bestellchat besprechen, inklusive Stundenplanerstellung."
      },
      {
        question: "Kann ich spielen, während die Bestellung aktiv ist?",
        answer: "Ja, das kannst du, es sei denn, du willst Premier spielen. Wenn du einen anderen Modus spielen willst, pausiere einfach oder plane ihn mit deinem Booster und hab Spaß!"
      },
      {
        question: "Kann ich denselben Booster auch für einen späteren Kauf anfordern?",
        answer: "Ja! Klicke im Bestell-Dashboard auf das Herzsymbol, um einen Booster zu deinen Favoriten hinzuzufügen, und weise ihn dann ganz einfach zukünftigen Bestellungen zu."
      }
    ],
    pt: [
      {
        question: "O Que É Um Serviço De Premier CS Rating Boost?",
        answer: "Um serviço de Premier CS Rating Boost é a melhor maneira de garantir que obténs o rating desejado com boosters de alto nível."
      },
      {
        question: "O Que Acontece Se Eu Perder CS Rating Durante O Serviço?",
        answer: "O serviço é 100% garantido. Se tal acontecer, iremos rapidamente recuperar e garantir que atinges o rating desejado."
      },
      {
        question: "Posso Jogar Com O Booster Em Duo?",
        answer: "Sim. Para isso basta clicar no botão acima com a palavra \"DUO\" no menu de edição do serviço."
      },
      {
        question: "Posso escolher o horário do meu booster?",
        answer: "Podes. Ao comprar um serviço podes adicionar o teu horário como informação adicional, ou podes clarificar esses e outros detalhes com o booster no chat do serviço."
      },
      {
        question: "Posso Jogar Enquanto O Serviço Está Activo?",
        answer: "Sim, a menos que queiras fazê-lo no mesmo modo de jogo do serviço comprado. Excepto isso, basta falares e agendares com o teu booster."
      },
      {
        question: "Posso escolher o mesmo Booster para uma compra futura?",
        answer: "Sim! Clica no ícone de coração dentro do painel do pedido para marcar um booster como favorito e depois escolhe-o facilmente nos teus próximos pedidos."
      }
    ],
    es: [
      {
        question: "¿Qué es exactamente un servicio Premier CS Rating Boost?",
        answer: "Un servicio de Boosting Premier es la mejor manera de garantizar que los boosters de primer nivel obtendrán tu Clasificación CS deseada."
      },
      {
        question: "¿Qué pasa si desciendo antes de que termine el servicio?",
        answer: "Nuestros servicios están garantizados al 100%. Si surge algún problema, lo solucionaremos rápidamente y nos aseguraremos de que alcances tu CS Rating objetivo."
      },
      {
        question: "¿Puedo jugar con el booster?",
        answer: "Por supuesto. Para ello, haz clic en el botón rojo \"DUO\" que encontrarás en el menú de añadir pedidos."
      },
      {
        question: "¿Puedo elegir mi horario de booster?",
        answer: "Sí, puedes hacerlo. Cuando hagas un pedido puedes añadir tu horario como una nota a tu booster, o puedes discutir cualquier detalle con tu booster, incluyendo la configuración de un horario., en el chat del pedido."
      },
      {
        question: "¿Puedo jugar mientras la orden está activa?",
        answer: "Sí, puedes, a menos que quieras jugar en Premier. En caso de cualquier otro modo, simplemente ponlo en pausa o prográmalo con tus boosters y ¡diviértete!"
      },
      {
        question: "¿Puedo solicitar el mismo booster para una futura compra?",
        answer: "¡Sí! Haz clic en el ícono de corazón dentro del panel del pedido para añadir un booster a favoritos y así poder reasignarlo fácilmente en tus futuros pedidos."
      }
    ]
  }


  private page = {
    title: {
      en: "Counter Strike 2 | Premier Rating & Rank Boosting",
      fr: "Counter Strike 2 | Rang Premier & Boosting de Rang",
      de: "Counter Strike 2 | Premier Rating & Rank Boosting",
      pt: "Counter Strike 2 | Boosting e classificação Premier",
      es: "Counter Strike 2 | Premier Rating & Rank Boosting",
    },
    metaDescription: {
      en: "Rise Counter Strike 2 Rating with GGBoost. Opt for the Best and Safest Boosting Services, ensuring Top Tier Performance Every Match",
      fr: "Augmentez votre rang sur Counter Strike 2 avec GGBoost. Optez pour les meilleurs services de boosting et les plus sûrs, garantissant des performances de haut niveau à chaque match.",
      de: "Verbessere dein Counter Strike 2 Rating mit GGBoost. Wähle den besten und sichersten Boosting-Service, der dir Spitzenleistungen in jedem Match garantiert.",
      pt: "Aumenta a tua classificação no Counter Strike 2 com GGBoost. Opta pelos melhores e mais seguros serviços de boosting, garantindo desempenho de alto nível em cada partida",
      es: "Aumenta la puntuación de Counter Strike 2 con GGBoost. Opta por los mejores y más seguros servicios de Boosting, garantizando un rendimiento de primer nivel en cada partida.",
    }
  }

  lang: string = 'en';

  constructor(meta: Meta, title: Title, private route: ActivatedRoute, private router: Router, private translationService: TranslationService, private cookie: CookieService) {
    this.route.params.subscribe(params => {
      if (Object.keys(params).length === 0) {
        const url = this.router.url.split('/');
        if (this.translationService.validLangs.includes(url[1])) {
          this.lang = url[1];
        } else {
          this.lang = this.cookie.get('gg-lang') || 'en';
        }
      } else {
        this.lang = params['lang'] || 'en';
      }

      title.setTitle(this.page.title[this.lang] || this.page.title['en']);
      meta.updateTag(
        {
          name: 'description',
          content: this.page.metaDescription[this.lang] || this.page.metaDescription['en']
        },
      );
    });
  }
}